// Prices at `/prices`. Service × old price × promo price table, plus
// PaymentsPromo strip.

import { Card, CardContent, CardHeader, CardTitle, H1, P } from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

import { AlertWord, PaymentsPromo } from '../components/brand'

export const Route = createFileRoute('/prices')({
  component: PricesPage,
})

const ROWS = [
  {
    service: 'Публикуване на ГФО (самообслужване)',
    oldPrice: '10 лв. / 5.11 €',
    newPrice: '7 лв. / 3.58 €',
    promo: true,
  },
  {
    service: 'Публикуване чрез E-mail (ние попълваме данните)',
    oldPrice: null,
    newPrice: '10 лв. / 5.11 €',
    promo: false,
  },
  {
    service: 'Консолидиран ГФО (повече от едно предприятие)',
    oldPrice: null,
    newPrice: '15 лв. / 7.67 €',
    promo: false,
  },
] as const

function PricesPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 px-6 py-8">
      <div className="space-y-2">
        <H1>Цени</H1>
        <P className="text-muted-foreground">
          Предлагаме едни от най-ниските цени за публикуване на годишен финансов отчет. Цените са
          крайни, с включен ДДС.
        </P>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Тарифа</CardTitle>
        </CardHeader>
        <CardContent>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left">
                <th className="py-2 pr-4 font-medium">Услуга</th>
                <th className="py-2 pr-4 font-medium">Стара цена</th>
                <th className="py-2 font-medium">Промоционална цена</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.service} className="border-b last:border-b-0">
                  <td className="py-3 pr-4">{row.service}</td>
                  <td className="py-3 pr-4 text-muted-foreground">
                    {row.oldPrice ? <s>{row.oldPrice}</s> : '—'}
                  </td>
                  <td className="py-3 font-medium">
                    {row.promo ? <AlertWord>{row.newPrice}</AlertWord> : row.newPrice}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>

      <P>
        Публикацията се запазва за <b>минимум 3 години</b>, както е регламентирано в{' '}
        <a href="/law#csch-38-7">чл. 38, ал. 7</a> от Закона за счетоводството. Достъпът до
        публикувания отчет е свободен и неплатен.
      </P>

      <PaymentsPromo />
    </div>
  )
}
